// pages/NewSectorPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { sectorService, uploadService } from "@cabukaka/services";
import SectorForm from "../../../components/features/sectors/SectorForm";
import { useToken } from "@cabukaka/hooks";

export default function NewSectorPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useToken();

  const generateSlug = (name: string) => {
    return name
      .toLowerCase()
      .trim()
      .replace(/[éèêë]/g, 'e')
      .replace(/[àâä]/g, 'a')
      .replace(/[îï]/g, 'i')
      .replace(/[ôö]/g, 'o')
      .replace(/[ùûü]/g, 'u')
      .replace(/[ç]/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  const handleSubmit = async (data: { name: string; logoFile?: File; existingLogo?: string , order: number }) => {
    setIsLoading(true);
    if (!token) {
      alertError("Veillez vous connecter ")
      return
    }
    try {
      let logoUrl = data.existingLogo  ;

      if (data.logoFile) {
        logoUrl = await uploadService.upload(data.logoFile, token!);
      }

      const slug = generateSlug(data.name);

      await sectorService.baseService.create({
        name: data.name,
        slug,
        logo: logoUrl || undefined,
        order: data.order
      } , token);

      alertSuccess("Secteur créé avec succès");
      navigate(-1);
    } catch (error: any) {
      alertServerError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageLayout title="Nouveau secteur">
      <PageContainer>
        <SectorForm
          onSubmit={handleSubmit}
          isSubmitting={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}